import React from 'react'
import ReactLoading from 'react-loading'

export default class Loading extends React.Component {
    onCancel = () => {
        this.props.onCancel(this.props.text)
    }

    render() {
        return (
            <div className="d-flex justify-content-center align-items-center">
                <ReactLoading
                    type={'bars'}
                    color={'var(--primary-light)'}
                    height={this.props.height || 120}
                    width={this.props.width || 120}
                />
            </div>
        )
    }
}
